module.exports = __webpack_public_path__ + "img/iceskating001.f6ebb6f4.jpg";